import { readable, writable } from 'svelte/store';

// Persistently store multiselect lists
export const bsDcList  =  writable([]);
export const bsStatusList  =  writable([]);
export const bsUnitList  =  writable([]);
export const bsConfirmList  =  writable([]);
export const bsAutobuyList  =  writable([]);
